import * as styles from './FormFieldsContainer.module.css'

function FormFieldsContainer({
  Element = 'div',
  children,
  className = styles.FormFieldsContainer,
  ref,
}) {
  return (
    <Element className={className} ref={ref}>
      {children}
    </Element>
  )
}

export default FormFieldsContainer
